<template>
  <div ref="actionNode" class="parentStyle" :style="sidebarStyles">
    <div class="p-4">
      <div style="margin-bottom: 1rem">
        <h4 style="font-weight: bold; text-align: left">Order Summary</h4>
        <table style="width: 100%">
          <tbody>
            <tr>
              <td align="left">Items ({{ itemCount }}):</td>
              <td align="right">{{ subTotal | currency }}</td>
            </tr>
            <tr>
              <td align="left">Shipping &amp; handling:</td>
              <td align="right">$0.00</td>
            </tr>
            <tr>
              <td align="left"></td>
              <td><hr style="margin: 0.75rem 0" /></td>
            </tr>
            <tr>
              <td align="left">Total before tax:</td>
              <td align="right">{{ subTotal | currency }}</td>
            </tr>
            <tr>
              <td align="left">Estimated tax to be collected:*</td>
              <td v-if="estimatedTax" align="right">
                {{ estimatedTax | currency }}
              </td>
              <td v-else align="right">TBD</td>
            </tr>
            <tr>
              <td colspan="2"><hr style="margin: 0.75rem 0" /></td>
            </tr>
            <tr>
              <td align="left">
                <h5
                  style="color: #d16c00; font-weight: bold; margin-top: 0.2rem"
                >
                  Order total:
                </h5>
              </td>
              <td align="right">
                <h5
                  style="color: #d16c00; font-weight: bold; margin-top: 0.2rem"
                >
                  {{ grandTotal | currency }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="editingPurchaseOrder"
        class="form-group"
        style="margin-bottom: 2rem"
      >
        <label for="poInput">Purchase Order</label>
        <div style="display: flex; flex-flow: row">
          <div class="input-group mr-3" style="flex: 1">
            <input
              id="poInput"
              v-model="poInput"
              type="text"
              class="form-control"
              style="border-radius: 1rem 0 0 1rem"
            />
            <div class="input-group-btn">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="handlePOInput"
              >
                Add
              </button>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            style="
              border-radius: 50%;
              padding: 0.5rem 1rem 0.25rem;
              border: none;
            "
            @click="editingPurchaseOrder = !editingPurchaseOrder"
          >
            <i class="fa fa-times fa-2x"></i>
          </button>
        </div>
      </div>
      <div v-else-if="purchaseOrder !== null" style="margin-bottom: 2rem">
        <label>Purchase Order</label>
        <div
          style="
            display: flex;
            flex-flow: row;
            align-items: center;
            margin-bottom: 1rem;
          "
        >
          <small
            style="
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-right: 0.5rem;
            "
          >
            {{ purchaseOrder }}
          </small>
          <button
            class="edit-po-button btn btn-secondary"
            type="button"
            @click="clearPOInput"
          >
            <small>Remove</small>
          </button>
        </div>
      </div>
      <p v-else style="margin-bottom: 2rem">
        <small>
          Want to add a purchase order number?
          <a
            href="javascript:void(0)"
            @click="editingPurchaseOrder = !editingPurchaseOrder"
          >
            Click here
          </a>
        </small>
      </p>
      <p v-if="!canCheckout">
        <small>
          Complete all required fields and accept product terms to estimate tax
        </small>
      </p>
      <button
        ref="submitBtn"
        type="submit"
        class="btn btn-primary btn-block"
        style="margin-top: 1.5rem"
        @click.prevent="handleSubmit"
      >
        Place your order
      </button>
      <span><a></a></span>
    </div>
    <div style="background-color: #eee" class="p-4">
      <div style="text-align: center">
        <small>
          By placing your order, you agree to Dictation.Cloud's privacy notice
          and end-user license agreement
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { mapGetters } from "vuex";
import currency from "../../../filters/currency";
import store from "../../../store/stores";

export default {
  store,
  filters: { currency },
  props: {
    stickyActive: {
      required: true,
      type: Boolean,
    },
    stickyYPos: {
      required: true,
      type: Number,
    },
    stickyEnd: {
      required: true,
      type: Boolean,
    },
    stickyEndPos: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      poInput: "",
      editingPurchaseOrder: false,
      oldSubTotal: undefined,
    };
  },
  computed: {
    ...mapGetters({
      itemCount: "checkout/cartItemsCount",
      subTotal: "checkout/cartSubTotal",
      grandTotal: "checkout/estimatedGrandTotal",
      canCheckout: "checkout/canCheckout",
      canGetTax: "checkout/canGetTax",
      checkoutSubmitError: "checkout/checkoutSubmitError",
      estimatedTax: "checkout/estimatedTax",
      purchaseOrder: "checkout/purchaseOrder",
      hasUpgradeableTestdrive: "checkout/hasUpgradeableTestdrive",
      hasUpgradeableNoImplementationFee:
        "checkout/hasUpgradeableNoImplementationFee",
    }),

    sidebarStyles() {
      if (this.stickyEnd) {
        return {
          position: "relative",
          marginTop: `${this.stickyEndPos}px`,
        };
      }

      if (this.stickyActive) {
        const width =
          this.$refs.actionNode.parentElement.getBoundingClientRect().width -
          30;

        return {
          position: "fixed",
          top: `${this.stickyYPos}px`,
          width: `${width}px`,
        };
      }

      return {};
    },
  },
  watch: {
    canGetTax(newValue) {
      if (
        newValue &&
        (this.oldSubTotal === "undefined" || this.oldSubTotal !== this.subTotal)
      ) {
        this.oldSubTotal = this.subTotal;
        this.handleEstimateTaxes();
      }
    },
  },
  methods: {
    getHeight() {
      return this.$refs.actionNode.getBoundingClientRect().height;
    },
    handleSubmit() {
      if (!this.canCheckout) {
        return this.alertError();
      }

      if (this.hasUpgradeableTestdrive) {
        return this.testdriveUpgradeableWarning();
      }

      if (this.hasUpgradeableNoImplementationFee) {
        return this.noImplementationFeeUpgradeableWarning();
      }

      return this.$store.dispatch("checkout/submit");
    },
    handleEstimateTaxes() {
      this.$store.dispatch("checkout/estimateTax");
    },
    alertError() {
      const error = this.checkoutSubmitError;

      swal.fire({
        title: "Uh oh...",
        type: "error",
        html: `<p style="font-size: small">${error}</p>`,
      });
    },
    /* eslint-disable */
    testdriveUpgradeableWarning() {
      swal
        .fire({
          title: "Did you mean to upgrade?",
          type: "warning",
          html: `<p style="font-size: small">
            By upgrading your Test Drives, you can maintain your user profile and data from the trial so
            you do not have to start over. To prevent losing any data with your speech profile, auto-texts,
            commands, and custom words, be sure to upgrade your trial. You cannot reuse the same email twice,
            so upgrading your current trial credentials avoids any issues. Click below to upgrade a
            Test Drive today.
            </p>`,
          showCloseButton: false,
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonText: `Proceed with data loss`,
          confirmButtonText: `Upgrade`,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.value) {
            swal.close();
            window.location.href = `/account/testdrives`;
          } else {
            swal.close();
            if (this.hasUpgradeableNoImplementationFee) {
              return this.noImplementationFeeUpgradeableWarning();
            }
            return this.$store.dispatch("checkout/submit");
          }
        });
    },
    noImplementationFeeUpgradeableWarning() {
      swal
        .fire({
          title: "You're about to upgrade some items in your cart",
          type: "warning",
          html: `<p style="font-size: small">
            By upgrading these items, all the information about subscribers will be transferred to this new order.
            </p>`,
          showCloseButton: false,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: `I Understand`,
          allowOutsideClick: false,
        })
        .then((result) => {
          swal.close();
          if (result.value) {
            return this.$store.dispatch("checkout/submit");
          }
        });
    },
    handlePOInput() {
      this.$store.commit("checkout/SET_PURCHASE_ORDER", this.poInput);
      this.editingPurchaseOrder = false;
    },
    clearPOInput() {
      this.poInput = "";
      this.$store.commit("checkout/SET_PURCHASE_ORDER", null);
      this.editingPurchaseOrder = false;
    },
  },
};
/* eslint-enabled */
</script>

<style scoped>
.parentStyle {
  display: flex;
  background: #ffffff;
  flex-direction: column;
  border: 0.1rem solid #eeeeee;
  border-radius: 1rem;
  overflow: hidden;
  margin-top: 3rem;
}

.edit-po-button {
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
}

.btn-outline-primary {
  border: 1px solid #d16c00;
  color: #d16c00;
  background: none;
}

.btn-outline-primary:hover {
  border: 1px solid #d16c00;
  color: #d16c00;
  background: #f5e1cc;
}

.purchase-order-alert {
  width: 400px;
  max-width: 90vw;
  padding: 1.5rem;
}

@media (min-width: 992px) {
  .parentStyle {
    margin-top: 0;
  }
}
</style>
